import StateMachine from '@shopee/state-machine';
import { TransitionEvent } from './constants';
import { OtpTransitionState } from '@shopee-user/otp-hook-base-constants';

export const stateMachine = new StateMachine<
  OtpTransitionState,
  TransitionEvent
>({
  defaultTransitions: {
    [TransitionEvent.Reset]: OtpTransitionState.Init,
    [TransitionEvent.ProceedToServiceUnavailable]:
      OtpTransitionState.ServiceUnavailable,
  },
  transitions: {
    [OtpTransitionState.Init]: {
      [TransitionEvent.ProceedToSelectOtpChannelInitial]:
        OtpTransitionState.SelectOtpChannelInitial,
      [TransitionEvent.ProceedToRequireOtp]: OtpTransitionState.RequireOtp,
      [TransitionEvent.ProceedToEnforceVoiceOtp]:
        OtpTransitionState.EnforceVoiceOtp,
    },
    [OtpTransitionState.RequireOtp]: {
      [TransitionEvent.BackToPrevious]: OtpTransitionState.Init,
      [TransitionEvent.ProceedToSelectOtpChannel]:
        OtpTransitionState.SelectOtpChannel,
      [TransitionEvent.ProceedToEnforceVoiceOtp]:
        OtpTransitionState.EnforceVoiceOtp,
      [TransitionEvent.ProceedToNext]: OtpTransitionState.Success,
    },
    [OtpTransitionState.EnforceVoiceOtp]: {
      [TransitionEvent.BackToPrevious]: OtpTransitionState.Init,
      [TransitionEvent.ProceedToNext]: OtpTransitionState.Success,
    },
    [OtpTransitionState.SelectOtpChannel]: {
      [TransitionEvent.BackToPrevious]: OtpTransitionState.RequireOtp,
      [TransitionEvent.ProceedToNext]: OtpTransitionState.RequireOtp,
    },
    [OtpTransitionState.SelectOtpChannelInitial]: {
      [TransitionEvent.BackToPrevious]: OtpTransitionState.Init,
      [TransitionEvent.ProceedToNext]: OtpTransitionState.RequireOtp,
    },
  },
});
